export enum ErrorType {
  NotFound = 'not-found',
  Critical = 'critical'
}

export const ImagePathByErrorType = {
  [ErrorType.NotFound]: 'assets/images/icons/not-found.svg',
  [ErrorType.Critical]: 'assets/images/icons/alert.svg'
};
